import React from 'react';
import {InputLabel,} from '@mui/material';
import SearchFilterAndSortGridItem from "./SearchFilterAndSortGridItem";
import SearchFilterAndSortFormControl from "./SearchFilterAndSortFormControl";
import SearchFilterAndSortContainer from "./SearchFilterAndSortContainer";
import SearchSortBySelect from "./SearchSortBy/SearchSortBySelect";
import SearchFilterLocationSelect from "./SearchFilter/SearchFilterLocationSelect";
import SearchFilterEquipmentSelect from "./SearchFilter/SearchFilterEquipmentSelect";
import {SearchFilterState} from "./SearchFilterState";

const SearchFilterAndSort = ({
    selectedEquipmentType, setSelectedEquipmentType, selectedLocationFeatures, setSelectedLocationFeatures, selectedSort, setSelectedSort
}: SearchFilterState) => {

    const handleEquipmentTypeOnChange = (event: any) => {
        setSelectedEquipmentType(event.target.value);
    }

    const handleLocationFeaturesOnChange = (event: any) => {
        setSelectedLocationFeatures(event.target.value);
    }

    const handleSelectedSortOnChange = (event: any) => {
        setSelectedSort(event.target.value);
    }

    return (
        <SearchFilterAndSortContainer>
            <SearchFilterAndSortGridItem>
                <SearchFilterAndSortFormControl>
                    <InputLabel id="equipment">Equipment Type</InputLabel>
                    <SearchFilterEquipmentSelect
                        labelId="equipment"
                        id="equipment"
                        value={selectedEquipmentType || []}
                        onChange={handleEquipmentTypeOnChange}
                    />
                </SearchFilterAndSortFormControl>
            </SearchFilterAndSortGridItem>
            <SearchFilterAndSortGridItem>
                <SearchFilterAndSortFormControl>
                    <InputLabel id="location-features">Location Features</InputLabel>
                    <SearchFilterLocationSelect
                            labelId="location-features"
                            id="location-features"
                            value={selectedLocationFeatures || []}
                            onChange={handleLocationFeaturesOnChange}
                    />
                </SearchFilterAndSortFormControl>
            </SearchFilterAndSortGridItem>
            <SearchFilterAndSortGridItem>
                <SearchFilterAndSortFormControl>
                    <InputLabel id="sort-by">Sort</InputLabel>
                    <SearchSortBySelect id="sort-by"
                                        labelId='sort-by'
                                        value={selectedSort}
                                        onChange={handleSelectedSortOnChange}
                    />
                </SearchFilterAndSortFormControl>
            </SearchFilterAndSortGridItem>
        </SearchFilterAndSortContainer>
    )
}

export default SearchFilterAndSort
